import React, { useState } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../nodeInstance";
import UploadFilePopUp from "../../../../ReusableComponents/UploadFile/uplaodFile";
import FinInsu from "./PopUpFile";

export default function ListFinInsurance({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
}) {
  const [Popup, setPopUp] = useState(false);

  const [editingIndex, setEditingIndex] = React.useState();
  const [amountValue, setAmountValue] = React.useState("");
  const [invoiceValue, setInvoiceValue] = React.useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [searchWords, setSearchWords] = useState([]);

  // list.border_number
  const handleInputChange = (event) => {
    setAmountValue(event.target.value);
    console.log(event.target.value);
  };

  // list.border_number
  const handleInvoiceChange = (event) => {
    setInvoiceValue(event.target.value);
    console.log(event.target.value);
  };
  const dispatch = useDispatch();

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const apiCall = () => {
    updateData("123654");
  };

  //edit text Field
  const handleEdit = (index, initialValue) => {
    setEditingIndex(index);
    setAmountValue(initialValue);
  };

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/employee-insurance/downloadInsuranceTemplate?finance=1`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Finance_Employee_insurance`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  //update Fields

  const update = async (type) => {
    try {
      // employees/downloadBorderNumberExcel
      console.log("Data to be printed here in the console", type);
      if (type.amount_paid === "") {
        dispatch(setAppError({ msg: "Amount field should not be empty" }));
        return;
      }
      const res = await nodeinstance.post("/employee-insurance/update/", type, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("res", res);
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.data.error,
        })
      );
    }
    setEditingIndex(-1);
    apiCall();
  };

  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => setPopUp(true)}
          >
            <p>Upload List</p>
            {/* {downloadLoading && <CgSpinner className="animate-spin" />} */}
          </button>
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
            onClick={() => downloadFile()}
            disabled={downloadLoading || list?.isLoading}
          >
            <p>Download</p>
            {downloadLoading && <CgSpinner className="animate-spin" />}
          </button>
          <Search
            searchKey={[
              "emp_id",
              "relation",
              "policy_no",
              "insurance_co",
              "insurance_no",
            ]}
            setSearchWords={setSearchWords}
          />
        </div>
        <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div className="relative bg-white">
          <div className="overflow-x-auto max-h-[70vh] ">
            <div className="sticky top-0 z-10 bg-white min-w-[2400px]">
              <div className="grid grid-cols-table-fininsurance gap-5 p-6 text-center">
                {titles.map((t, index) => (
                  <p key={index} className="font-semibold uppercase">
                    {t}
                  </p>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-table-fininsurance gap-5 p-6 bg-white text-center">
              {list?.isLoading && (
                <LoadingWithLable className="col-span-full" />
              )}
              {!list?.isLoading && <NoDataFound />}
              {!list?.isLoading &&
                currentList.map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.emp_id || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.relation || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.marital_status || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.class || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={"" || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.policy_no || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.apply_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.issue_date || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.insurance_co || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.membership_no || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.insurance_no || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.status || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.policy_coverage_days || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.total_amount || "-"}
                      />
                    </p>

                    <p>
                      {editingIndex === index ? (
                        <input
                          type="text"
                          name={list.amount_paid}
                          className={`input input-sm h-10 max-w-xs  w-full 
                      input-bordered focus:outline-none uppercase`}
                          id={list.amount_paid}
                          defaultValue={list.amount_paid}
                          required="er"
                          onChange={(e) => {
                            handleInputChange(e);
                          }}
                        />
                      ) : (
                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={list.amount_paid || "-"}
                          />
                        </p>
                      )}
                    </p>

                    <p>
                      {editingIndex === index ? (
                        <input
                          type="text"
                          name={list.invoice_number}
                          className={`input input-sm h-10 max-w-xs  w-full 
                      input-bordered focus:outline-none uppercase`}
                          id={list.invoice_number}
                          defaultValue={list.invoice_number}
                          required="er"
                          onChange={(e) => {
                            handleInvoiceChange(e);
                          }}
                          // onChange={}
                        />
                      ) : (
                        <p>
                          <Highlighter
                            searchWords={searchWords}
                            autoEscape={true}
                            textToHighlight={list.invoice_number || "-"}
                          />
                        </p>
                      )}
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.insurance_status || "-"}
                      />
                    </p>
                    <button
                      className={
                        editingIndex === index
                          ? "px-2 rounded-md  bg-green-500 text-white text-xs p-2 w-20"
                          : "px-2 rounded-md  bg-red text-white text-xs p-2 w-20"
                      }
                      onClick={() => {
                        if (editingIndex === index) {
                          if (amountValue !== null) {
                            update({
                              employee_id: list.emp_id,
                              amount_paid: amountValue,
                              invoice_number: invoiceValue,
                            });
                          } else {
                            dispatch(
                              setAppError({
                                msg: "Please Enter Amount Paid ",
                              })
                            );
                          }
                        } else {
                          handleEdit(index, list.amount_paid);
                          setAmountValue(list.amount_paid);
                          setInvoiceValue(list.invoice_number);
                        }
                      }}
                      disabled={
                        list.insurance_status_value.toString() === "3"
                          ? true
                          : false
                      }
                    >
                      {editingIndex === index ? "Save" : "Update"}
                    </button>
                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>

        <Pagination />
      </div>
      {Popup ? (
        <FinInsu
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Upload Insurance"}
          url={"employee-insurance/updateFinance/New"}
          callBack={apiCall}
        />
      ) : (
        ""
      )}
    </>
  );
}
